import {
  AXIOS_ADMIN_AUTHED,
  AXIOS_UNAUTHED,
  getApiUrl,
  getAxiosInstanceByLoginMode,
  getUsApiUrl
} from './shared';

const getRegionSelection = () => {
  return AXIOS_UNAUTHED.get(
    `${getUsApiUrl()}/public/configuration-list/region-selection-enabled`
  );
};

const getApplicationConfigurations = () => {
  return getAxiosInstanceByLoginMode().get(`${getApiUrl()}/configuration-list`);
};

const update = (appConfigs) => {
  return AXIOS_ADMIN_AUTHED.put(
    `${getApiUrl()}/configuration-list/patch`,
    appConfigs
  );
};

export { getRegionSelection, getApplicationConfigurations, update };
